import { UnitCurrentStatus, UnitsSource } from "api/units";

export interface UnitsFilters {
  states: string[];
  cities: string[];
  property_group_ids: number[];
  property_ids: number[];
  unit_ids: number[];
  current_statuses: UnitCurrentStatus[];
  owner_ids: number[];
  sources: UnitsSource[];
}

export const EMPTY_UNITS_FILTERS: UnitsFilters = {
  states: [],
  cities: [],
  property_group_ids: [],
  property_ids: [],
  unit_ids: [],
  current_statuses: [],
  owner_ids: [],
  sources: []
};

export const countActiveUnitsFilters = (filters: UnitsFilters) =>
  Object.values(filters).reduce((total, values) => total + values.length, 0);
